import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { HYDRA_CHECKOUT_MOVE_TO_FAVORITES } from 'constants/hydraTests';

import { isAssigned } from 'actions/ab';
import { pluralize } from 'helpers';
import { isDesktop } from 'helpers/ClientUtils';
import DigitalItem from 'components/checkout/melody/review/DigitalItem';
import RetailItem from 'components/checkout/melody/review/RetailItem';
import { hasGcQuantity } from 'helpers/CheckoutUtils';
import css from 'styles/components/checkout/melody/review/reviewItems.scss';

export class ReviewItems extends Component {
  state = {
    showItems: false
  };

  componentDidMount = () => {
    const { marketplace } = this.context;
    if (isDesktop(marketplace)) {
      this.setState({ showItems: true });
    }
  }

  toggleIsOpen = e => {
    e.preventDefault();
    const { onToggleItems } = this.props;
    const { showItems } = this.state;
    onToggleItems && onToggleItems(showItems);
    this.setState({ showItems: !showItems });
  };

  render() {
    const { testId = f => f, marketplace: { checkout: { allowGiftOptions, allowMoveToFavorites } } } = this.context;
    const { showItems } = this.state;
    const {
      isAssignedInCMTF,
      isMainReviewSection,
      isReviewStep,
      melodyCheckoutData: {
        asinErrors,
        constraintViolations,
        isLoading: isFetchingCheckoutData,
        numItems,
        purchase: { eligibleForGiftWrap, productList }
      },
      onChangeQuantity,
      onMoveToFavoritesClick,
      onViewGiftOptionsClick
    } = this.props;
    const hasGcQuantityCv = hasGcQuantity(constraintViolations);

    if (showItems || isMainReviewSection) {
      return (
        <div>
          {
            productList.map((product, i) => {
              const { gcCustomization } = product;
              const isLastItem = i === productList.length - 1;
              if (gcCustomization) {
                return <DigitalItem
                  asinErrors={asinErrors}
                  hasGcQuantityCv={hasGcQuantityCv}
                  isFetchingCheckoutData={isFetchingCheckoutData}
                  isLast={isLastItem}
                  isReviewStep={isReviewStep}
                  key={product.lineItemId}
                  onChangeQuantity={onChangeQuantity}
                  product={product} />;
              } else {
                return <RetailItem
                  allowGiftOptions={allowGiftOptions}
                  allowMoveToFavorites={allowMoveToFavorites && isAssignedInCMTF}
                  asinErrors={asinErrors}
                  eligibleForGiftWrap={eligibleForGiftWrap}
                  isFetchingCheckoutData={isFetchingCheckoutData}
                  isLast={isLastItem}
                  isReviewStep={isReviewStep}
                  key={product.lineItemId}
                  onChangeQuantity={onChangeQuantity}
                  onMoveToFavoritesClick={onMoveToFavoritesClick}
                  onViewGiftOptionsClick={onViewGiftOptionsClick}
                  product={product} />;
              }
            })
          }

          { !isMainReviewSection && <div className={css.reviewItemsWrapper}>
            <button
              type="button"
              className={css.showItemsBtn}
              data-test-id={testId('hideItemsBtn')}
              onClick={this.toggleIsOpen}>Hide {pluralize('Item', numItems)}</button>
          </div>
          }
        </div>
      );
    }

    return (
      <div className={css.reviewItemsWrapper}>
        <button
          type="button"
          className={css.showItemsBtn}
          data-test-id={testId('showItemsBtn')}
          onClick={this.toggleIsOpen}>Show {numItems} {pluralize('Item', numItems)}</button>
      </div>
    );
  }
}

ReviewItems.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

function mapStateToProps(state) {
  const { melodyCheckoutData, routing: { locationBeforeTransitions } } = state;
  const isAssignedInCMTF = isAssigned(HYDRA_CHECKOUT_MOVE_TO_FAVORITES, 1, state);

  return {
    isAssignedInCMTF,
    melodyCheckoutData,
    location: locationBeforeTransitions
  };
}

export default connect(mapStateToProps, {
})(ReviewItems);
